export const KAKAO_OAUTH_PROVIDER_INPUT_NAME = 'oauth-provider-kakao'
export const APPLE_OAUTH_PROVIDER_INPUT_NAME = 'oauth-provider-apple'
export const LINE_OAUTH_PROVIDER_INPUT_NAME = 'oauth-provider-line'
export const GOOGLE_OAUTH_PROVIDER_INPUT_NAME = 'oauth-provider-google'

export const KAKAO_SOCIAL_LOGIN_BACKGROUND_COLOR = '#F9E000'
export const KAKAO_SOCIAL_LOGIN_HOVER_BACKGROUND_COLOR = '#FFF7AD'

export const KAKAO_OAUTH_REDIRECT_URI = 'https://kauth.kakao.com/oauth/authorize'
export const APPLE_OAUTH_REDIRECT_URI = 'https://appleid.apple.com/auth/authorize'
